import "./Loader.scss";
import clsx from "clsx";

import { useSidebarLayout } from "@/context/SidebarLayoutContext";

import logo from "../../assets/NIRALogo.webp";

interface LoaderProps {
  readonly size?: number; // Optional, defaults to 48
  text?: string | null; // Optional, defaults to "Loading"
  classname?: string | null;
}

function Loader({ size = 48, text = null, classname = null }: LoaderProps) {
  const { isCollapsed } = useSidebarLayout();

  return (
    <div
      className={clsx(classname, "behavior", {
        collapsed: isCollapsed,
      })}
    >
      <img
        src={logo}
        className="loader"
        style={{ width: size, height: size, marginBottom: size / 2 }}
      />
      {text ? <span className="loader-text">{text}</span> : null}
    </div>
  );
}

export default Loader;
